<tm-header
    class="property-theme"
    [tradeMeUrl]="tradeMeUrl"
    [myTradeMeUrl]="myTradeMeUrl"
    [myPhotoUrl]="myPhotoUrl"
></tm-header>
